import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { GtagService } from './../analytics/gtag.service';
import { Agency } from './../models/index';

@Injectable()
export class AgencyService {

  _agency: Agency = new Agency();

  get agency(): Agency {
    return this._agency;
  }

  constructor(
    private apiCallService: ApiCallService
  ) { }

  public getAgency(): Promise<Agency> {
    const promise = this.apiCallService.get('');

    if (promise) {
      promise.then(response => {
        this._agency = response;
        GtagService.updatePhoneConversion(this._agency);
      });
    }

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/agency.service.ts